<div class="flex-direction-column gap-10">
  <span class="font-12 weight-600">Forma de envio:</span>
  <div class="flex gap-10">
    <app-slide-toggle-padrao
      [labelTrue]="'WhatsApp'"
      [labelFalse]="''"
      [valor]="ehWhatsapp()"
      [disabled]="bloqueado"
      (changeValue)="selecionarCanal(CanalTemplateEnum.WHATSAPP)">
    </app-slide-toggle-padrao>

    <app-slide-toggle-padrao
      [labelTrue]="'SMS'"
      [labelFalse]="''"
      [valor]="!ehWhatsapp()"
      [disabled]="bloqueado"
      (changeValue)="selecionarCanal(CanalTemplateEnum.SMS)">
    </app-slide-toggle-padrao>
  </div>
</div>
